module.exports = __webpack_public_path__ + "img/lg_ring_g_l_0_null.80f39a99.png";